const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ');

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const SHADE_TITLE_TOKENS = [
  'Gold Ros',
  'Gold Rose',
  'Rose Gold',
  'Dusty Rose',
  'Bronze Glow',
  'Bronze',
  'Champagne',
  'Pearl',
  'Ivory',
  'Beige',
  'Nude',
  'Peach',
  'Pink',
  'Coral',
  'Ruby',
  'Red',
  'Brown',
  'Mocha',
  'Espresso',
  'Black',
  'White',
  'Silver',
  'Clear',
  'Light',
  'Medium',
  'Dark',
  'Ros',
  'Rose',
  'Glow',
  'Gold',
];

const cleanTitle = (title, options) => {
  let next = normalize(title);
  const tokens = new Set([...options, ...SHADE_TITLE_TOKENS]);

  for (const option of options) {
    option.split(/\s+/).forEach((token) => {
      if (token.length > 1) tokens.add(token);
    });
  }

  for (const option of [...tokens].sort((a, b) => b.length - a.length)) {
    if (!option) continue;
    next = next.replace(new RegExp(`\\b${escapeRegExp(option)}\\b`, 'gi'), '');
  }

  return normalize(next.replace(/\s+,/g, ',').replace(/\s+-\s+/g, ' ')) || normalize(title);
};

const withVariantPrefix = (title, variantLabel) => {
  const clean = normalize(title);
  const variant = normalize(variantLabel);
  if (!variant || variant.toLowerCase() === 'default title') return clean;
  if (clean.toLowerCase().startsWith(variant.toLowerCase())) return clean;
  return normalize(`${variant} ${clean}`);
};

const getSelectedVariantLabel = (root) => {
  const picker = root.closest('product-component')?.querySelector('variant-picker') || root.closest('.shopify-section')?.querySelector('variant-picker');
  if (!picker) return '';

  const checked = picker.querySelectorAll('input[data-option-name]:checked');
  for (const input of checked) {
    const value = normalize(input.value);
    if (value && value.toLowerCase() !== 'default title') return value;
  }

  const selects = picker.querySelectorAll('select');
  for (const select of selects) {
    const value = normalize(select.value || select.selectedOptions?.[0]?.value);
    if (value && value.toLowerCase() !== 'default title') return value;
  }

  return '';
};

const syncTitle = (titleEl) => {
  const original = titleEl.dataset.fenisaTitleOriginal || titleEl.textContent || '';
  const options = (titleEl.dataset.fenisaOptions || '')
    .split('|')
    .map(normalize)
    .filter(Boolean);
  const variantLabel = getSelectedVariantLabel(titleEl) || titleEl.dataset.fenisaInitialVariant || '';

  titleEl.textContent = withVariantPrefix(cleanTitle(original, options), variantLabel);

  let variantEl = titleEl.parentElement?.querySelector('[data-fenisa-selected-variant]');
  if (variantEl) {
    variantEl.hidden = true;
  }
};

const syncAllTitles = (root = document) => {
  root.querySelectorAll('[data-fenisa-product-title]').forEach(syncTitle);
};

let frame = 0;
const schedule = (root = document) => {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => syncAllTitles(root));
};

document.addEventListener('change', (event) => {
  if (event.target instanceof Element && event.target.closest('variant-picker')) {
    schedule(event.target.closest('product-component') || document);
  }
}, true);

document.addEventListener('input', (event) => {
  if (event.target instanceof Element && event.target.closest('variant-picker')) {
    schedule(event.target.closest('product-component') || document);
  }
}, true);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) schedule(event.target);
});

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches('[data-fenisa-product-title], product-component') || node.querySelector('[data-fenisa-product-title]')) {
        schedule(node);
        return;
      }
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => syncAllTitles(), { once: true });
} else {
  syncAllTitles();
}
